module.exports = __webpack_public_path__ + "img/futsal.75c58161.svg";